import React, { useState, useEffect } from 'react';
import { Trophy, Fire, Target, ChartLineUp } from '@phosphor-icons/react';
import { motion } from 'framer-motion';
import api from '@/utils/api';

const ProgressStats = () => {
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchStats();
  }, []);

  const fetchStats = async () => {
    try {
      const response = await api.get('/users/progress');
      setStats(response.data);
    } catch (error) {
      console.error('Failed to fetch progress stats:', error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
        {[1, 2, 3, 4].map((i) => (
          <div key={i} className="bg-white/5 border border-white/10 rounded-xl p-4 animate-pulse">
            <div className="h-8 bg-white/10 rounded w-1/2 mb-2"></div>
            <div className="h-4 bg-white/10 rounded w-3/4"></div>
          </div>
        ))}
      </div>
    );
  }

  if (!stats) return null;

  const statItems = [
    {
      label: 'Current Streak',
      value: stats.current_streak,
      suffix: 'days',
      icon: Fire,
      color: 'text-orange-400',
      bgColor: 'from-orange-500/20 to-red-500/20',
    },
    {
      label: 'This Week',
      value: stats.weekly_content_created,
      suffix: 'posts',
      icon: Target,
      color: 'text-blue-400',
      bgColor: 'from-blue-500/20 to-cyan-500/20',
    },
    {
      label: 'Total Created',
      value: stats.total_content_created,
      suffix: 'posts',
      icon: Trophy,
      color: 'text-yellow-400',
      bgColor: 'from-yellow-500/20 to-amber-500/20',
    },
    {
      label: 'Completion Rate',
      value: stats.completion_rate,
      suffix: '%',
      icon: ChartLineUp,
      color: 'text-emerald-400',
      bgColor: 'from-emerald-500/20 to-teal-500/20',
    },
  ];

  return (
    <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
      {statItems.map((item, index) => {
        const Icon = item.icon;
        return (
          <motion.div
            key={index}
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: index * 0.1 }}
            className={`bg-gradient-to-br ${item.bgColor} border border-white/10 rounded-xl p-4`}
          >
            <div className="flex items-center justify-between mb-2">
              <Icon size={24} weight="fill" className={item.color} />
              <span className={`text-2xl font-bold text-white`}>
                {item.value}
                <span className="text-sm font-normal text-slate-400 ml-1">{item.suffix}</span>
              </span>
            </div>
            <p className="text-sm text-slate-400">{item.label}</p>
          </motion.div>
        );
      })}
    </div>
  );
};

export default ProgressStats;
